module.exports = __webpack_public_path__ + "static/media/M002-account.59e15acd.svg";